import React from 'react'
import { ArticleHeading, Section } from '../content'
import { md } from '../../lib/remarkable'
import GoogleMapView from './GoogleMapView'
const cache = require('memory-cache')

import axios from 'axios'

function BlockMap ({ title, value, suburbId, location, children }) {
  const [geo, setGeo] = React.useState(undefined)
  React.useEffect(() => {
    const cached = cache.get(`geometry-${suburbId}`)
    if (cached) setGeo(cached)
    else axios.get(`${process.env.REACT_APP_API_URL}/suburbs/${suburbId}?_fields=geometry`).then(r => {
      cache.put(`geometry-${suburbId}`, r.data.geometry)
      setGeo(r.data.geometry)
    })
  }, [suburbId])

  const html = React.useMemo(() => {
    if (!value) return null
    return <div>{md.render(value)}</div>
  }, [value])

  const { geometry, marker } = React.useMemo(() => {
    const r = {
      geometry: null,
      marker: null
    }
    if (geo) {
      r.geometry = {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            geometry: (typeof geo === 'string') ? JSON.parse(geo) : geo,
          },
        ],
      }
    }
    if (location) {
      r.marker = {
        lat: location.latitude,
        lng: location.longitude,
      }
    }
    return r
  }, [suburbId, location, geo])

  return (
    <Section>
      { title && <ArticleHeading>{title}</ArticleHeading> }
      { geometry && <GoogleMapView marker={marker} geometry={geometry}/> }
      {html}
      {children}
    </Section>
  )
}

export default BlockMap
